import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { LocalizationService } from './localization.service';

@Injectable({
    providedIn: 'root'
})
export class NotifyService {
    constructor(
        private localizationService:LocalizationService,
        private messageService:MessageService
    ) { }

    notifyError(error) {
        // Lisans limiti mesajları hata değil uyarıdır — sarı warning toast olarak gösterilir.
        if (this.isLicenseLimitWarning(error)) {
            this.notifyWarning(error);
            return;
        }

        this.messageService.clear();
        this.messageService.add({
            severity: 'error',
            summary: this.localizationService.translatedTextList.Error,
            detail: error,
            life: 3000,
          });
    }

    notifyWarning(message) {
        this.messageService.clear();
        this.messageService.add({
            severity: 'warn',
            summary: this.localizationService.translatedTextList.LicenseWarningTitle,
            detail: message,
            life: 6000,
          });
    }

    notifySuccess(message) {
        this.messageService.clear();
        this.messageService.add({
            severity: 'success',
            summary: this.localizationService.translatedTextList.Successful,
            detail: message,
            life: 3000,
          });
    }

    // Backend, limit aşımında message key'i döner; interceptor bunu çevirmiş de
    // ham key olarak bırakmış da olabilir — iki formu da yakala.
    private isLicenseLimitWarning(error): boolean {
        const list = this.localizationService.translatedTextList;
        return error === 'GlobalSearchTokenLimitExceeded'
            || error === 'CvScoringLicenseLimitExceeded'
            || error === list?.GlobalSearchTokenLimitExceeded
            || error === list?.CvScoringLicenseLimitExceeded;
    }
}
